import { render, staticRenderFns } from "./sold-products.vue?vue&type=template&id=549edffc&scoped=true"
import script from "./sold-products.vue?vue&type=script&lang=js"
export * from "./sold-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549edffc",
  null
  
)

export default component.exports